import { UseQueryResult, useQuery } from "react-query";

import { TUseQueryOptions } from "../../../hooks";
import { IAssetsModel } from "../../types";
import { api } from "../../utils";
import { useAuth } from "../useAuth";

export const useGetAssetById = (
    queryKey: string,
    assetId: string,
    options?: TUseQueryOptions<any, unknown, IAssetsModel, string>,
): UseQueryResult<IAssetsModel, unknown> => {
    const auth = useAuth();
    return useQuery(
        queryKey,
        async () => {
            if (!auth.token) {
                throw new Error(
                    `Cannot fetch asset with ID: ${assetId} without authorization token.`,
                );
            }
            return await api.Asset.getById(assetId, auth.token);
        },
        options,
    );
};
